import { incotermsService } from "@/_services";
export const incoterm = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    entity: {
      data: [],
      status: {},
    },
    delete: {
      data: [],
      status: {},
    },
    update: {
      data: [],
      status: {},
    },
    post: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getIncotermsRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getIncotermsSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getIncotermsError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    deleteIncotermRequest(state) {
      state.delete.status = {
        deleting: true,
      };
    },
    deleteIncotermError(state, error) {
      state.delete.data = null;
      state.delete.status = {
        error,
      };
    },
    deleteIncotermSuccess(state, response) {
      state.delete.data = response;
      state.delete.status = {
        deleted: true,
      };
    },
    postIncotermRequest(state) {
      state.post.status = {
        creating: true,
      };
    },
    postIncotermError(state, error) {
      state.post.data = null;
      state.post.status = {
        error,
      };
    },
    postIncotermSuccess(state, response) {
      state.post.data = response;
      state.post.status = {
        created: true,
      };
    },
    updateIncotermRequest(state) {
      state.update.status = {
        updating: true,
      };
    },
    updateIncotermError(state, error) {
      state.update.data = null;
      state.update.status = {
        error,
      };
    },
    updateIncotermSuccess(state, response) {
      state.update.data = response;
      state.update.status = {
        updated: true,
      };
    },
    getIncotermByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getIncotermByIdError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    getIncotermByIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
  },
  actions: {
    getIncoterms({ commit }, request) {
      commit("getIncotermsRequest");
      incotermsService
        .getIncoterms(request.pagination, request.query)
        .then((response) => {
          commit("getIncotermsSuccess", response);
        })
        .catch((error) => {
          commit("getIncotermsError", error);
        });
    },
    deleteIncoterm({ commit }, id) {
      commit("deleteIncotermRequest");
      incotermsService
        .deleteIncoterm(id)
        .then((res) => {
          commit("deleteIncotermSuccess", res);
        })
        .catch((error) => {
          commit("deleteIncotermError", error);
        });
    },
    postIncoterm({ commit }, request) {
      commit("postIncotermRequest");
      incotermsService
        .postIncoterm(request)
        .then((res) => {
          commit("postIncotermSuccess", res);
        })
        .catch((error) => {
          commit("postIncotermError", error);
        });
    },
    updateIncoterm({ commit }, request) {
      commit("updateIncotermRequest");
      incotermsService
        .updateIncoterm(request.id, request.body)
        .then((res) => {
          commit("updateIncotermSuccess", res);
        })
        .catch((error) => {
          commit("updateIncotermError", error);
        });
    },
    getIncotermById({ commit }, id) {
      commit("getIncotermByIdRequest");
      incotermsService
        .getIncotermById(id)
        .then((res) => {
          commit("getIncotermByIdSuccess", res);
        })
        .catch((error) => {
          commit("getIncotermByIdError", error);
        });
    },
  },
};
